import { type ApiFn, useBaseApiCall } from '@/api/factory/base/api';
import {
  type DefaultError,
  type QueryKey,
  type UseQueryOptions,
  useQuery,
} from '@tanstack/react-query';

export const useMakeQuery = <
  TQueryFnData = unknown,
  TError = DefaultError,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>(
  config: Omit<
    UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
    'queryFn'
  > & {
    apiFn: ApiFn<TQueryFnData>;
  },
) => {
  const { apiFn, ...queryConfig } = config;

  return useQuery({
    ...queryConfig,
    queryFn: useBaseApiCall<TQueryFnData>(apiFn),
  });
};
